<input matInput 
	(input)="searchRegion()"
	(focusin)="setFocusIn()"
	(focusout)="setFocusOut($event)"
	#regionInput
	[matAutocompleteConnectedTo]="connectedFormField()"
	[formControl]="regionControl" 
	[matAutocomplete]="auto"
	(blur)="markTouched()"/>
<mat-autocomplete #auto="matAutocomplete" 
	class="select__panel--surface"
	[displayWith]="displayRegion"
	[root]="auto.panel"
	appIntersectionObserver 
	requireSelection
	(intersecting)="loadRegions()"
	(optionSelected)="markTouched()"
		rootMargin="0px 0px 20% 0px" >
		@if(selectableCountries()?.data; as countries){
			@for (region of countries; track region.iso2; let last = $last) {
				@if(last){
					<mat-option
						[value]="region"
						appObserve>{{region.name}}</mat-option>
				}
				@else {
					<mat-option
						[value]="region">
						{{region.name}}</mat-option>
				}
			}
	}
</mat-autocomplete>